import { CardModule } from 'primeng/card';
import { Component, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule, Location } from '@angular/common';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { Router } from '@angular/router';
import { Toast } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { LeadProfileMiddleScreenComponent } from 'src/app/private/components/leads/lead-profile-middle-screen/lead-profile-middle-screen.component';
import { LeadTimelineComponent } from 'src/app/private/components/leads/lead-timeline/lead-timeline.component';
import { LeadFollowupFormComponent } from 'src/app/private/components/leads/lead-followup-form/lead-followup-form.component';
import { AddNoteComponent } from 'src/app/private/components/leads/add-note/add-note.component';
import { LeadEmailComponent } from "../lead-email/lead-email.component";
import { LeadTaskComponent } from "../lead-task/lead-task.component";
import { LeadMeetingComponent } from "../lead-meeting/lead-meeting.component";
import { LeadCallComponent } from "../lead-call/lead-call.component";
import { ActivatedRoute } from '@angular/router';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LeadService } from 'src/app/private/services/lead.service';
import { UsersService } from 'src/app/private/services/users.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { LeadActivityService } from 'src/app/private/services/micro-services/leadactivity.service';
import { RegistrationService } from 'src/app/private/services/registration.service';
import { catchError, forkJoin, of } from 'rxjs';
import { UploadService } from 'src/app/private/services/upload.service';
import { FeeService } from 'src/app/private/services/fee-service.service';
@Component({
  selector: 'app-lead-profile',
  imports: [CardModule, CommonModule, FormsModule, AvatarModule, ButtonModule, InputTextModule, DropdownModule,
    DividerModule, DialogModule,
    SelectModule, LeadProfileMiddleScreenComponent, Toast, LeadTimelineComponent, LeadFollowupFormComponent, AddNoteComponent, LeadEmailComponent, LeadTaskComponent, LeadMeetingComponent, LeadCallComponent, ProgressSpinnerModule, ConfirmDialogModule],
  providers: [MessageService, ConfirmationService],
  templateUrl: './lead-profile.component.html',
  styleUrl: './lead-profile.component.scss'
})
export class LeadProfileComponent {

  selectedTabIdx = 0;
  lead_id: any = '';
  initialLoading = true;
  leadDetails: any = {};
  users: any = [];
  fullUserList: any = [];
  allLeadFeilds: any = [];

  selectedOwner = '';
  selectedStatus = ''
  selectedRegistrationStatus = '';
  selectedApplicationStatus = '';
  selectedEnrollmentStatus = '';
  selectedType = '';
  selectedQueryType = '';
  selectedSource = '';
  selectedPipelineId: any = null;
  selectedPipelineScore: number | null = null;
  loading = false;
  applicationOwner = '';
  leadActivity: any = [];
  editType: string | null = null;
  previewImage: string | null = null;
  
  pipelineStages: any[] = [];
  selectedDefaultPipelineId: any = null;

  leadSources: any[] = [
    { label: 'Channel Partner', value: 'Channel Partner' },
    { label: 'Conference', value: 'Conference' },
    { label: 'Field Visit', value: 'Field Visit' },
    { label: 'Google', value: 'Google' },
    { label: 'Instagram', value: 'Instagram' },
    { label: 'Lead Gen Tools', value: 'Lead Gen Tools' },
    { label: 'Live Session', value: 'Live Session' },
    { label: 'Personal', value: 'Personal' },
    { label: 'Referral', value: 'Referral' },
    { label: 'LinkedIn', value: 'LinkedIn' },
    { label: 'Website', value: 'Website' },
    { label: 'WhatsApp', value: 'WhatsApp' },
    { label: 'Tina', value: 'Tina' },
    { label: 'Intern', value: 'Intern' },
    { label: 'Other', value: 'Other' }
  ];

  leadTypes: any[] = [
    { label: 'New Lead', value: 'New Lead' },
    { label: 'Cold Lead', value: 'Cold Lead' },
    { label: 'Warm Lead', value: 'Warm Lead' },
    { label: 'Hot Lead', value: 'Hot Lead' }
  ];

  leadStatusList: any[] = [];


  registrationStatusList: any[] = [
    { value: 'Pending', label: 'Pending' },
    { value: 'Under Review', label: 'Under Review' },
    { value: 'Accepted', label: 'Accepted' },
    { value: 'Rejected', label: 'Rejected' }
  ];

  applicationStatusList: any[] = [
    { value: 'In Progress', label: 'In Progress' },
    { value: 'Completed', label: 'Completed' },
    { value: 'Canceled', label: 'Canceled' }
  ];

  enrollmentStatusList: any[] = [
    { value: 'Under Review', label: 'Under Review' },
    { value: 'In Progress', label: 'In Progress' },
    { value: 'Completed', label: 'Completed' },
    { value: 'Canceled', label: 'Canceled' }
  ];

  queryTypes: any[] = [
    { label: 'General', value: 'General' },
    { label: 'Admission', value: 'Admission' },
    { label: 'Application', value: 'Application' },
    { label: 'Fee Structure', value: 'Fee Structure' },
    { label: 'Registration', value: 'Registration' },
    { label: 'Placement', value: 'Placement' },
    { label: 'Alumni', value: 'Alumni' },
    { label: 'Course', value: 'Course' },
    { label: 'Other', value: 'Other' }
  ];

  allCourses: any[] = [];
  fullCourseList: any[] = [];
  paymentForList: any[] = [];

  accessObject: any = {};

  constructor(private messageService: MessageService,
    private location: Location,
    private route: ActivatedRoute,
    private api: LeadService,
    private localStorage: LocalStorageService,
    private userApi: UsersService,
    private leadActivityService: LeadActivityService,
    private registrationApi: RegistrationService,
    private uploadService: UploadService,
    private feeGroupApi: FeeService,
    private router: Router,
    private confirmationService: ConfirmationService
  ) {
    this.lead_id = this.route.snapshot.paramMap.get('id');

    this.route.url.subscribe((segments) => {
      console.log('Segments:', segments);
      if (segments.length >= 2) {
        this.editType = segments[0].path; // 'registration' or 'leads'
      }
    });

    console.log('Edit Type:', this.editType);

    this.accessObject = this.localStorage.checkCRUDAccess('lead', 'manual');

    console.log("Access Object: ", this.accessObject.isMoveToRegistrationAccess);

  }

  ngOnInit() {
    this.getLeadDetails();
    this.getAllUsers();
    this.getLeadsFields();
    
    // Only load pipelines for leads editType
    if (this.editType === 'leads') {
      this.loadPipelineStages();
    }

    if (this.editType === 'registration' || this.editType === 'application' || this.editType === 'enrollment') {
      this.getAllCourses();
    }

    if(this.editType === 'enrollment'){
      this.getAllActiveFeeGroups();
    }


    this.leadActivityService.leadActivity$.subscribe((leadActivity) => {
      this.leadActivity = leadActivity
    });
  }

  getAllCourses() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
    };
    this.registrationApi.getAllCourses(param).subscribe({
      next: (data) => {
        this.allCourses = data || [];
        this.fullCourseList = data || [];
        this.allCourses = this.allCourses.map((course: any) => {
          course.course_id = parseInt(course.course_id);
          return course;
        }
        );
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  getAllActiveFeeGroups() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
    };

    this.feeGroupApi.getAllActiveFeeGroups(param).subscribe({
      next: (data) => {
        console.log('Active Fee Groups:', data);
        this.paymentForList = data?.map((feeGroup: any) => ({
          label: feeGroup.group_name,
          value: feeGroup.id,
          total_fees: feeGroup.total_fees
        })) || [];
        console.log('Payment For List:', this.paymentForList);
      },
      error: (e) => {
        console.error('Error fetching active fee groups:', e);
      },
    });
  }



  getLeadDetails(isUpdate = false) {

    this.api.getLead({ lead_id: this.lead_id }).subscribe({
      next: (response) => {
        console.log('Lead Details:', response);
        this.initialLoading = false;
        this.leadDetails = response;

        console.log('Lead Details:', this.leadDetails);

        this.selectedOwner = this.leadDetails.assigned_to;
        this.selectedStatus = this.leadDetails.lead_status;
        this.selectedType = this.leadDetails.lead_type;
        this.selectedQueryType = this.leadDetails.query_type;
        this.selectedSource = this.leadDetails.source;
        this.selectedPipelineId = this.leadDetails.pipeline_id || this.selectedDefaultPipelineId;
        this.selectedPipelineScore = this.leadDetails.lead_score;
        this.selectedRegistrationStatus = this.leadDetails.registration?.status;
        this.selectedApplicationStatus = this.leadDetails.application_data?.status;
        this.applicationOwner = this.leadDetails.application_data?.assign_to;
        this.selectedEnrollmentStatus = this.leadDetails.enrollment_data?.enrollment_status;

        if (this.editType === 'enrollment') {
          this.selectedOwner = this.leadDetails.enrollment_data?.assign_to;
        }

        if (isUpdate) {
          this.loading = false;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Profile Updated Successfully' });
        }

        console.log('Selected Owner:', this.selectedOwner);

      },
      error: (error) => {
        console.log('Error:', error);
        this.initialLoading = false;
      }
    }
    );

  }

  getAllUsers() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
    };
    this.userApi.findAllUsers(param).subscribe({
      next: (res: any) => {
        this.users = res || [];
        this.fullUserList = res || [];
        this.users = this.users.map((user: any) => {
          return {
            label: user.fname + " " + user.lname,
            value: user?.user_id
          };
        }
        );
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }

  getLeadsFields() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      module_type: this.editType === 'leads' ? 'lead' : (this.editType || 'lead')
    };
    this.api.getLeadsFields(param).subscribe({
      next: (data) => {
        this.allLeadFeilds = data?.fields.sort((a: any, b: any) => a.sequence - b.sequence);
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  loadPipelineStages() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      pipeline_type: 'lead'
    };
    this.api.getAllPipelines(param).subscribe({
      next: (res: any) => {
        if (res && res.length > 0) {
          // find set_default true pipeline id
          const defaultPipeline = res.find((pipeline: any) => pipeline.set_default === true);
          if (defaultPipeline) {
            this.selectedDefaultPipelineId = defaultPipeline.id;
          }
          this.pipelineStages = res.map((pipeline: any) => ({
            label: pipeline.pipeline_name,
            value: pipeline.id,
            stages: pipeline.stages
          }));
          
          // Load stages for the default or current pipeline
          if (this.leadDetails.pipeline_id) {
            const currentPipeline = this.pipelineStages.find(p => p.value === this.leadDetails.pipeline_id);
            this.leadStatusList = currentPipeline?.stages || [];
          } else if (this.selectedDefaultPipelineId) {
            const defaultPipe = this.pipelineStages.find(p => p.value === this.selectedDefaultPipelineId);
            this.leadStatusList = defaultPipe?.stages || [];
          }
        }
      },
      error: (e: any) => {
        console.error('Error loading pipeline stages:', e);
      },
    });
  }

  getFullName() {
    let user = this.leadDetails;
    return [user?.first_name, user?.last_name]
      .filter(name => !!name)
      .map(name => name.split(' ') // Split by space to handle multiple words
        .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')) // Rejoin capitalized words
      .join(' ');
  }

  getName() {
    let user = this.leadDetails;
    return [user?.first_name, user?.last_name]
      .filter(name => !!name)
      .join(' ');
  }

  onPipelineChange(event: any) {
    const selectedPipelineId = event.value;
    if (selectedPipelineId && this.pipelineStages && this.pipelineStages.length > 0) {
      const selectedPipeline = this.pipelineStages.find(p => p.value === selectedPipelineId);
      this.leadStatusList = selectedPipeline?.stages || [];
      
      // Reset lead status and score when pipeline changes
      this.selectedStatus = '';
      this.selectedPipelineScore = null;
    }
  }

  onStatusChange(event: any) {
    const selectedStatusName = event.value;
    if (selectedStatusName && this.leadStatusList && this.leadStatusList.length > 0) {
      const selectedStage = this.leadStatusList.find((stage: any) => stage.stage_name === selectedStatusName);
      if (selectedStage && selectedStage.score !== undefined) {
        this.selectedPipelineScore = selectedStage.score;
      }
    }
  }

  updateData(data: any) {

    this.selectedStatus = data.lead_status;
    this.selectedType = data.lead_type;
    this.selectedQueryType = data.query_type;
    this.selectedSource = data.source;
    this.selectedPipelineId = data.pipeline_id || this.selectedDefaultPipelineId;
    this.selectedPipelineScore = data.lead_score;
    this.selectedRegistrationStatus = data.reg_data?.status;
    this.selectedApplicationStatus = data.application_data?.status;
    this.selectedEnrollmentStatus = data.enrollment_data?.enrollment_status;

    if (this.editType == 'enrollment') {
      this.selectedOwner = data.enrollment_data?.assign_to;
    } else {
      this.selectedOwner = data.assigned_to;
    }
  }


  handleSaveQuickActions() {

    const payload: any = {
      ...this.leadDetails,
      old_lead_data: this.leadDetails,
      assigned_to: this.selectedOwner,
      lead_status: this.selectedStatus,
      lead_type: this.selectedType,
      query_type: this.selectedQueryType,
      source: this.selectedSource,
      pipeline_id: this.selectedPipelineId,
      lead_score: this.selectedPipelineScore,
      user_id: this.localStorage.getUserId(),
      user: this.localStorage.getUser(),
    };

    if (this.editType === 'registration') {
      payload.reg_data = {
        ...this.leadDetails.registration,
        status: this.selectedRegistrationStatus
      };
    }

    if (this.editType === 'application') {
      this.loading = true;
      const payload2 = {
        organization_id: this.localStorage.getOrganizationId(),
        application_id: [this.leadDetails.application_data?.application_id],
        status: this.selectedApplicationStatus,
        assign_to: this.applicationOwner,
        old_data : this.leadDetails.application_data,
        new_data : { ...this.leadDetails.application_data, status: this.selectedApplicationStatus, assign_to: this.applicationOwner,
          assignedUser: this.fullUserList.find((user: any) => user.user_id === this.applicationOwner) || this.leadDetails.application_data?.assignedUser,
          course : this.fullCourseList.find((course: any) => course.course_id === this.leadDetails.application_data?.course_id) || this.leadDetails.application_data?.course
         },
        lead_id: this.leadDetails.lead_id,
        user_id: this.localStorage.getUserId()
      };

      const updateApplicationNeeded = this.selectedApplicationStatus !== this.leadDetails.application_data?.status || this.applicationOwner !== this.leadDetails.assigned_to
      const updateLeadNeeded = this.selectedSource !== this.leadDetails.source;

      const updateCalls = [];

      if (updateApplicationNeeded) {
        updateCalls.push(
          this.api.updateApplication(payload2).pipe(
            catchError(error => {
              console.log('Error updating application:', error);
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update application.' });
              return of(null); // continue with other requests
            })
          )
        );
      }

      if (updateLeadNeeded) {
        updateCalls.push(
          this.api.updateLead(payload).pipe(
            catchError(error => {
              console.log('Error updating lead:', error);
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update lead.' });
              return of(null);
            })
          )
        );
      }

      if (updateCalls.length > 0) {
        forkJoin(updateCalls).subscribe({
          next: (responses) => {
            console.log('All updates done:', responses);
            this.getLeadDetails(true);
            this.leadActivityService.getAllLeadTimeLineActivity(this.lead_id);
            // this.loading = false;
          },
          error: (err) => {
            // This shouldn't trigger often since we catch errors inside
            console.log('Unexpected error:', err);
            this.loading = false;
          }
        });
      } else {
        this.loading = false; // no updates needed
      }

      return;
    }

    if (this.editType === 'enrollment') {
      this.loading = true;
      const payload2 = {
        organization_id: this.localStorage.getOrganizationId(),
        enrollment_id: [this.leadDetails.enrollment_data?.enrollment_id],
        enrollment_status: this.selectedEnrollmentStatus,
        assign_to: this.selectedOwner,
      };

      const updateEnrollmentNeeded = this.selectedEnrollmentStatus !== this.leadDetails.enrollment_data?.status || this.selectedOwner !== this.leadDetails.enrollment_data?.assign_to;
      const updateLeadNeeded = this.selectedSource !== this.leadDetails.source;

      const updateCalls = [];

      if (updateEnrollmentNeeded) {
        updateCalls.push(
          this.api.updateEnrollment(payload2).pipe(
            catchError(error => {
              console.log('Error updating enrollment:', error);
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update enrollment.' });
              return of(null); // continue with other requests
            })
          )
        );
      }

      if (updateLeadNeeded) {
        updateCalls.push(
          this.api.updateLead(payload).pipe(
            catchError(error => {
              console.log('Error updating lead:', error);
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update lead.' });
              return of(null);
            })
          )
        );
      }

      if (updateCalls.length > 0) {
        forkJoin(updateCalls).subscribe({
          next: (responses) => {
            console.log('All updates done:', responses);
            this.getLeadDetails(true);
            this.leadActivityService.getAllLeadTimeLineActivity(this.lead_id);
            // this.loading = false;
          },
          error: (err) => {
            // This shouldn't trigger often since we catch errors inside
            console.log('Unexpected error:', err);
            this.loading = false;
          }
        });
      } else {
        this.loading = false; // no updates needed
      }

      return;
    }

    this.loading = true;
    this.api.updateLead(payload).subscribe({
      next: (response) => {
        console.log('Update Lead:', response);
        this.getLeadDetails(true);
        this.leadActivityService.getAllLeadTimeLineActivity(this.lead_id);
      },
      error: (error) => {
        this.loading = false;
        console.log('Error:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong' });
      }
    });

  }


  isAddNote = false;
  isEmailLead = false;
  isAddTask = false;
  isAddMeeting = false;
  isCallLead = false;

  handleCopy() {
    console.log('Copied');
    let email = this.leadDetails.email;
    navigator.clipboard.writeText(email);
    this.messageService.add({ severity: 'success', summary: 'Email copied', detail: 'Email copied to clipboard' });
  }

  handleTabChange(event: any) {
    this.selectedTabIdx = event;
  }

  handleBack() {
    console.log('Back');
    this.location.back();
  }

  handleOpenNoteDialog() {
    this.isAddNote = true;
  }

  handleOpenEmailLead() {
    const emailMode = this.localStorage.getDefaultEmailCommunicationMode();
    
    if (emailMode === 'none' || !emailMode) {
      this.confirmationService.confirm({
        message: 'Your communication medium is not connected. Please connect your communication medium to send email.',
        header: 'Communication Medium Not Connected',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Connect Communication',
        rejectLabel: 'Cancel',
        acceptButtonStyleClass: 'p-button-warning',
        accept: () => {
          this.confirmationService.close();
          this.router.navigate(['/main/settings/configuration-panel'], { queryParams: { activeTab: 1 } });
        },
        reject: () => {
          this.confirmationService.close();
        }
      });
      return;
    }
    
    this.isEmailLead = true;
  }

  handleOpenMeetingDialog() {
    this.isAddMeeting = true;
  }

  handleOpenCallLead() {
    this.isCallLead = true;
  }

  handleOpenTaskDialog() {
    this.isAddTask = true;
  }

  handleCloseNoteDialog() {
    this.isAddNote = false;
  }

  handleCloseEmailDialog() {
    this.isEmailLead = false;
  }

  handleCloseTaskDialog() {
    this.isAddTask = false;
  }

  handleCloseMeetingDialog() {
    this.isAddMeeting = false;
  }

  handleCloseCallDialog() {
    this.isCallLead = false;
  }

  getInitials() {
    let name = this.getName();
    if (!name) {
      return "GR";
    }

    const initialName = name
      .split(' ')
      .filter(n => n && n.trim().length > 0) // Filter out empty or whitespace-only strings
      .map(n => n[0].toUpperCase())
      .join('');

    return initialName.length > 2 ? initialName.slice(0, 2) : initialName;
  }

  async onProfileImageUpload(event: Event): Promise<any> {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files[0]) {
      const file = input.files[0];

      // Show image immediately using FileReader
      const reader = new FileReader();

      reader.onload = async (e: ProgressEvent<FileReader>) => {
        const result = e.target?.result;
        if (typeof result === 'string') {
          this.previewImage = result;

          this.messageService.add({
            severity: 'info',
            summary: 'Info',
            detail: 'Uploading Image...',
          });

          try {

            const imageUrl = await this.uploadToS3(file);

            const payload = {
              ...this.leadDetails,
              profile_pic: imageUrl,
              lead_id: this.lead_id,
              user_id: this.localStorage.getUserId(),
              old_lead_data: this.leadDetails,
            };

            this.api.updateLead(payload).subscribe({
              next: (response) => {
                console.log('Profile Image Updated:', response);
                
                // update the current data 
                this.leadDetails.profile_pic = imageUrl;

                this.messageService.clear();
                this.messageService.add({
                  severity: 'success',
                  summary: 'Success',
                  detail: 'Profile Image Updated Successfully'
                });
                this.leadActivityService.getAllLeadTimeLineActivity(this.lead_id);
              },
              error: (error) => {
                console.error('Error:', error);
                this.messageService.clear('upload');
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: 'Something went wrong'
                });
              }
            });
          } catch (error) {
            console.error('Upload failed:', error);
            this.messageService.clear('upload');
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to upload image.'
            });
          }
        }
      };

      reader.readAsDataURL(file);
    }
  }

  async uploadToS3(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      const folder = `education/students/documents`;
      formData.append('file', file);
      formData.append('folders', folder);
      formData.append('bucket', 'global-upload-storage');

      this.uploadService.uploadDocuments(formData).subscribe({
        next: (response: any) => {
          console.log('File uploaded successfully:', response);
          resolve(response.url); // Assuming API returns { url: 's3-url' }
        },
        error: (error) => {
          console.error('Error uploading file:', error);
          reject('');
        },
      });
    });
  }


}
